export const sortLatestFirst = (list, dateColumnName) => {
  var temp = JSON.parse(JSON.stringify(list));
  temp.reverse();

  temp.map((a) => {
    let dd = new Date(a[dateColumnName])
      .toISOString()
      .replace(/T.*/, "")
      .split("-")
      .reverse()
      .join("-");
    a[dateColumnName] = dd;
  });
  return temp;
};
export const latestRecordsFirst = (list, dateColumnName) => {
  var temp = JSON.parse(JSON.stringify(list));

  temp.map((a) => {
    let dd = new Date(a[dateColumnName])
      .toISOString()
      .replace(/T.*/, "")
      .split("-")
      .reverse()
      .join("-");
    a[dateColumnName] = dd;
  });
  return temp;
};

export const searchForMatch = (fieldValues, valueToMatch) => {
  return fieldValues?.toLowerCase().includes(valueToMatch.toLowerCase());
};

export const getTotal = (arr, key) => {
  return arr.reduce((acc, val) => acc + val[key], 0);
};

export const getYearFromDateStr = (dateStr) => {
  const monthList = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  if(!dateStr){
    return ["","",""];
    
  }
  const [year, month, date] = dateStr.split("-");
  
  return [year,monthList[parseInt(month)-1],date];
};

export const getFormattedNumber = (number = 0, decimalCount = 2) => {
  return parseFloat(number).toFixed(decimalCount)
}

export const  roundToTwo =(num) => {
  return +(Math.round(num + "e+2")  + "e-2");
}
